<template>
	<div class="main" ref="main">
    <!-- <div :class="currentMenuFenZu&&currentMenuFenZu=='xmzx'?'tools tools2':'tools'"> -->
    <div class="tools3">
			<el-select v-model="AppID" placeholder="请选择应用" style="margin-right: 10px;" @change="selectApp">
				<el-option
					v-for="item in AppList"
					:key="item.AutoID"
					:label="item.应用名称"
					:value="item.AutoID">
				</el-option>
			</el-select>
			<el-button type="primary" size="small" class="bt-text" @click="openDialog($event, 'new')" :disabled="!loaded"><i class="el-icon-circle-plus-outline"></i>添加</el-button>
			<el-button type="text" class="bt-text" @click="openDialog($event, 'edit')" :disabled="!loaded"><i class="el-icon-edit edit-icon"></i>编辑</el-button>
			<el-button type="text" class="bt-text" @click="del($event)" :disabled="!loaded"><i class="el-icon-delete delete-icon"></i>删除</el-button>
			<el-button type="text" class="bt-text" @click="openDialog($event, 'update')" :disabled="!loaded"><i class="el-icon-edit-outline delete-icon"></i>变更</el-button>
			
			<el-button type="text" class="bt-text" @click="shunxu('up')" :disabled="!loaded || !!filterText"><i class="el-icon-top move-icon"></i>上移</el-button>
			<el-button type="text" class="bt-text" @click="shunxu('down')" :disabled="!loaded || !!filterText"><i class="el-icon-bottom move-icon"></i>下移</el-button>
			<el-button type="text" class="bt-text" @click="refreshShunxu()" :disabled="!loaded || !!filterText"><i class="el-icon-refresh"></i>重算子级顺序</el-button>
			<el-button type="primary" size="small" plain @click="expandAllNodes(true)" v-if="!expandAll"><i class="el-icon-plus"></i>展开</el-button>
			<el-button type="primary" size="small" plain @click="expandAllNodes(false)" v-else><i class="el-icon-minus"></i>收起</el-button>
      <el-input
        placeholder="输入关键字进行过滤"
        v-model="filterText"
        size="small"
        style="width: 200px; margin-left: 15px;"
        v-if="loaded">
      </el-input>
    </div>
    
		<div class="cont" :style="'height: ' + tableHeight + 'px; padding: 0px 5px;'">
			<el-tree
			  :data="data"
			  checkbox
			  node-key="ID"
			  :default-expand-all="expandAll"
			  :expand-on-click-node="false"
			  :default-expanded-keys="expandedKeys"
			  ref="tree"
			  style="width: 100%;"
			  @node-click="getNode"
			  :filter-node-method="filterNode"
			  highlight-current
			  >
			  <span class="custom-tree-node" slot-scope="{ node, data }" :class="checked? 'chkw':''">
			  <span>
			    <img src="/static/images/folder-open.png" class="node-icon" v-if="node.expanded==true"/>
			    <img src="/static/images/folder.png" class="node-icon" v-if="node.expanded==false"/>
					{{ node.label }}
			  </span>
			
			  </span>
			</el-tree>
			<br />
			
		</div>
    <el-dialog id="newDialog" ref="newDialog" :title="formTitle" :visible.sync="dialogFormVisible" width="450px" :close-on-click-modal="false" v-dialogDrag>
      <div class="dialog-container">
        <el-form ref="form" :model="form" :rules="rules" label-width="100px" v-if="dialogFormVisible&&loaded && (type=='new' || type=='edit')">

          <el-form-item label="上级目录" prop="ParentID">
            <el-input v-model="form.上级目录" readonly="readonly" v-if="form.上级目录"></el-input>
						<el-input value="根目录" readonly="readonly" v-else></el-input>
						
          </el-form-item>
          <el-form-item label="目录名称" prop="目录名称">
            <el-input v-model="form.目录名称"></el-input>
          </el-form-item>
          
          <el-row>
            <el-button ref="sendButton" type="primary" @click="submitForm('form')" size="small">保存</el-button>
            <el-button ref="sendButton" type="warning" @click="closeDialog" size="small">关闭</el-button>
          </el-row>
        </el-form>
				<el-form ref="form" :model="form2" :rules="rules2" label-width="100px" v-if="dialogFormVisible && type=='update'">
				
				  <el-form-item label="上级目录" prop="ParentID">
				    <TreeSelect :props="props" :options="data" :value="form2.ParentID" :label="form2.上级目录" :clearable="true" :accordion="false" @getValue="getValue"></TreeSelect>
				  </el-form-item>
				  <el-form-item label="目录名称" prop="目录名称">
				    <el-input v-model="form2.目录名称" readonly="readonly"></el-input>
				  </el-form-item>
				  
				  <el-row>
				    <el-button ref="sendButton" type="primary" @click="submitForm('form')" size="small">保存</el-button>
				    <el-button ref="sendButton" type="warning" @click="closeDialog" size="small">关闭</el-button>
				  </el-row>
				</el-form>
      </div>
			
    </el-dialog>

	</div>
</template>

<script>

  import {WeiZhi,translateDataToTree,GetUserInfo,Alert} from "@/utils/util.js"
  import '@/utils/directives.js';
	import * as util from "@/utils/util.js"
	import TreeSelect from "@/components/TreeSelect.vue";
	
  let id=1000;

  export default {
    data() {
      return {
        isClearable:true,      // 可清空（可选）
        isAccordion:true,      // 可收起（可选）
        props:{                // 配置项（必选）
          value: 'ID',
          label: 'label',
          pathkey: 'PathKey',
          children: 'children',
					keyValue: 'ID',
          // disabled:true
        },
        form: {
          AutoID: '0',
          ParentID: '0',
          上级目录: '',
          目录名称: '',
          AppID: '0',
        },
        form2: {
          AutoID: '0',
          ParentID: '0',
          上级目录: '',
          目录名称: '',
          AppID: '0',
        },
        props:{                // 配置项（必选）
          value: 'ID',
          label: 'label',
          pathkey: 'PathKey',
          children: 'children',
					keyValue: 'ID',
          // disabled:true
        },
        data: [],
        mlData: [],
        currentID: 0,
        ParentID: '0',
        currentNode: [],
        currentNodeType: '',
        checked: false,
        currentField: '',
        isEdit: false,
        lbDisabled: false,
        dialogFormVisible: false,
        currentPathkey: '0',
        formTitle: '',
        loaded: false,
        rules: {
          目录名称: [
            { required: true, message: '请输入目录名称', trigger: 'change' }
          ],
          
        },
        rules2: {
          上级目录: [
            { required: true, message: '请选择上级目录', trigger: 'change' }
          ],
          
        },
        copyedData: '',
        filterText: '',
        expandAll: false,
        expandedKeys: ['0'],
				currentUserInfo: {},
				dingShiQiArr: [],	//定时器列表
				tableHeight: 400,
				dialogVisible2: false,
				dialogTitle2: '',
				dialogName2: 'newDialog_bgbj2',
				type2: '',
				AppList: [],
				AppID: '',
				
      }
    },
		components: {TreeSelect},
    methods: {
      filterNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
      },
      submitForm(formName) {
				if(!this.AppID || this.AppID=='0'){
					util.Alert('请先选择应用！');
					return;
				}
				
				
        this.$refs[formName].validate((valid) => {
          if (valid) {
            //console.log(JSON.stringify(this.form));
            //alert('submit!');

            if(this.type=="new")
            {
              let url="/Handler/MuLu.ashx?mode=new";
              this.$ajax.post(url,this.form).then((response)=>{
                //console.log(response.data);

                let value=response.data;

                let type=value.errorCode;

                this.currentID=value.AutoID;

                if(type=="0")
                {
                  this.$message({
                    type: 'success',
                    message: '添加成功'
                  });
                  this.closeDialog();
                  this.requestData();
									
                }
                else
                {
                  let desc=value.desc;
                  this.$message({
                    type: 'success',
                    message: '添加失败: ' + desc
                  });

                }

              },function(err){
                //console.log(err);
              });
            }
            else if(this.type=='edit')
            {
              let url="/Handler/MuLu.ashx?mode=edit";
              this.$ajax.post(url,this.form).then((response)=>{
                //console.log(response.data);

                let value=response.data;

                let type=value.errorCode;

                
                if(type=="0")
                {
									this.currentID=value.AutoID;
									
                  this.$message({
                    type: 'success',
                    message: '编辑成功'
                  });
                  this.resetForm("form");
                  this.closeDialog();
                  this.requestData();
									
                }
                else
                {
                  let desc=value.desc;
                  // this.$message({
                  //   type: 'warning',
                  //   message: '编辑失败: ' + desc
                  // });
									Alert('编辑失败: ' + desc);
                }

              },function(err){
                //console.log(err);
              });
            }
						else if(this.type=='update')
						{
						  let url="/Handler/MuLu.ashx?mode=edit";
						  this.$ajax.post(url,this.form2).then((response)=>{
						    //console.log(response.data);
						
						    let value=response.data;
						
						    let type=value.errorCode;
						
						    
						    if(type=="0")
						    {
									this.currentID=value.AutoID;
									
						      this.$message({
						        type: 'success',
						        message: '变更成功'
						      });
						      this.resetForm("form");
						      this.closeDialog();
						      this.requestData();
									
						    }
						    else
						    {
						      let desc=value.desc;
						      // this.$message({
						      //   type: 'warning',
						      //   message: '编辑失败: ' + desc
						      // });
									Alert('变更失败: ' + desc);
						    }
						
						  },function(err){
						    //console.log(err);
						  });
						}

          } else {
           //console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      del() {
        if(this.currentID!=0) {
          this.remove(this.$refs.tree.getCurrentNode(),this.currentID);
        } else {
          this.$message({
            type: 'info',
            message: '请先选择节点'
          });
        }
      },
      remove(node, id) {
        this.$confirm('确定要删除节点“' + node.label + '”吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          // const parent = node.parent;
          //console.log(parent);
          // const children = parent.data.children || parent.data;
          // const index = children.findIndex(d => d.id === id);
          const child = node.children;
          //alert(JSON.stringify(child));
          if(!child||child.length===0) {
            //children.splice(index, 1);
            let pathKey=this.currentPathkey;
						let url="/Handler/MuLu.ashx?mode=delMuLu";
            this.$ajax.post(url,{AutoID: id}).then((response)=>{
              //console.log(response.data);

              let value=response.data;

              let errorCode=value.errorCode;
              let desc=value.desc;

              if(errorCode==="0")
              {
                this.$refs.tree.remove(node);

                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
              } else {
                this.$message({
                  type: 'warning',
                  message: '删除失败!' + desc
                });
              }
            },function(err){
              //console.log(err);
            });

          } else {
            this.$message({
              type: 'warning',
              message: '节点“' + node.label + '”包含子节点，不能删除!'
            });
          }

        }).catch((e) => {
          this.$message({
            type: 'info',
            message: '已取消删除' + e
          });
        });

      },
      requestData(){
				if(!this.AppID || this.AppID=='0'){
					Alert('请选择应用名称！');
					return;
				}
        let url="/Handler/MuLu.ashx?mode=GetMuLuList";
        this.$ajax.post(url,{AppID: this.AppID}).then((response)=>{
          //console.log(response.data);
          //console.log(JSON.stringify(response.data));
          let errorCode=response.data.errorCode;
          if(errorCode=='0')
          {
            this.currentNode = response.data.data.find(item=>item.AutoID==this.currentID);

            this.data = [{label: '根目录', ID: '0', AutoID: '0',disabled: true, children: translateDataToTree(response.data.data,'目录名称','目录名称')}];

            this.mlData=this.filterData(JSON.parse(JSON.stringify(this.data)));

            this.$nextTick(function(){
              if(this.currentNode!=undefined&&this.currentNode!='')
              {
                this.$refs.tree.setCurrentNode(this.currentNode);
              }
              this.loaded=true;
              let t=this.filterText;
              this.filterText='';
              let t2 = setTimeout(()=>{
                this.filterText=t;
              },10);
							
							this.dingShiQiArr.push(t2);
							
              this.expandAllNodes(this.expandAll);  //根据当前设置（expandAll）展开/收起Tree

              console.log(this.currentNode,this.currentID);

              if(this.currentNode){
                this.expandedKeys=[this.currentNode.ID];  //展开当前节点
              }
            })
          }
          //console.log(response.data);        },function(err){
          //console.log(err);
        });
      },
      getNode(data) {
        let node = this.$refs.tree.getCurrentNode();
        if(node!==null && node!==undefined)
        {
          //console.log(node);

          this.currentNode=this.$refs.tree.getCurrentNode();
          this.currentID=node.AutoID;
          this.form.上级目录=node.label;
          this.form.PathKey=node.PathKey;
          this.form.ParentID=node.ID;
          this.ParentID=node.ParentID;
          //console.log("pathkey:", this.form);
					
					sessionStorage.setItem('MuLuID', this.currentID);
					
					console.log('this.currentID', this.currentID);
        }

      },
      openDialog(event, type) {
        if (type == 'new') {
          
          this.type = 'new';
          this.formTitle = '帮助目录';

          this.form.目录名称='';
          this.form.AppID=this.AppID;
          
          //this.form.pathkey=this.currentPathkey;
          //this.form.ParentID=this.currentID;
          this.dialogFormVisible = true;
          this.isEdit=false;
          this.loaded=true;

        }
        else if (type == 'paste') {

          this.type = 'new';
          this.formTitle = '新建目录';
					//this.form.pathkey=this.currentPathkey;
          //this.form.ParentID=this.currentID;
          this.dialogFormVisible = true;
          this.isEdit=false;
          this.loaded=true;

        }
        else if (type == 'edit') {
          this.type = 'edit';
          this.formTitle = '编辑目录';
          //this.form.pathkey=this.currentPathkey;
          //this.form.id=this.currentID;
          //this.dialogFormVisible = true;
          this.isEdit=true;
          this.lbDisabled=false;

          if (this.currentID == 0) {
            this.$message({
              type: 'error',
              message: '请先选择要编辑的目录'
            });
            this.dialogFormVisible = false;            //console.log("ddd");
          }
          else
          {
            //console.log(event);
            this.requestMuLuData();
          }
        }
				else if (type == 'update') {
				  this.type = 'update';
				  this.formTitle = '变更父目录';
				  //this.form.pathkey=this.currentPathkey;
				  //this.form.id=this.currentID;
				  // this.dialogFormVisible = true;
				  this.isEdit=true;
				  this.lbDisabled=false;
				
				  if (this.currentID == 0) {
				    this.$message({
				      type: 'error',
				      message: '请先选择要变更的目录'
				    });
				    this.dialogFormVisible = false;
				  }
				  else
				  {
				    //console.log(event);
				    this.requestMuLuData();
				  }
				}

        let weizhi=WeiZhi(event,450, 450,0,0,1);
        //console.log(weizhi);

        let l=weizhi.left;
        let t=weizhi.top;

        //const el = this.$refs['newDialog'];
				let el=document.querySelector('#newDialog');
        const dragDom = el.querySelector('.el-dialog');
				
				//console.log(dragDom,l,t)
        dragDom.style.marginTop = '0px';
        dragDom.style.left = l + 'px';
        dragDom.style.top = t + 'px';

        //console.log(l, t, screenWidth, screenHeight);
        //console.log(event.clientY, event.clientX);
      },
      closeDialog() {
        this.dialogFormVisible = false;
        //this.resetForm("form");

      },
			requestMuLuData(){
				this.form={};
				let loading;
				
				let t = setTimeout(() => {
				  loading = this.$loading({
				    lock: true,
				    text: "正在请求数据，请勿刷新页面！！！",
				    spinner: "el-icon-loading",
				    background: "rgba(0, 0, 0, 0.3)",
				  });
				}, 100);
				
        let url="/Handler/MuLu.ashx?mode=GetMuLuInfo";
        this.$ajax.post(url,{AppID: this.AppID, AutoID: this.currentID}).then((response)=>{
          //console.log(response.data);
          //let jsonData=JSON.parse(response.bodyText);
          let errorCode=response.data.errorCode;

          if(errorCode=='0')
          {
            let jsonData=response.data.data[0];
            //console.log(jsonData[0]);
            this.form=jsonData;
            this.form2=jsonData;
            
            this.loaded=true;
						this.dialogFormVisible = true;
						
						clearTimeout(t);
						
						if (loading) {
						  loading.close();
						}
          }

          //console.log(this.form);
        },function(err){
          //console.log(err);
					clearTimeout(t);
					
					if (loading) {
					  loading.close();
					}
        });
      },
      shunxu(type) {
        if (this.currentID == 0) {
          this.$message({
            type: 'error',
            message: '请先选择要调整的分类'
          });
          return;
        }

        let url="/Handler/MuLu.ashx?mode=" + type;
        this.$ajax.post(url,{AutoID: this.currentID, ParentID: this.ParentID}).then((response)=>{
          //console.log(response.data);
          //let jsonData=JSON.parse(response.bodyText);
          //console.log(jsonData[0]);
          //this.currentID=0;
          let value=response.data;

          let errorCode=value.errorCode;

          if(errorCode=="0")
          {

            this.requestData();

          }
          else
          {
            let desc=value.desc;
            this.$message({
              type: 'error',
              message: desc
            });
          }        },function(err){
          //console.log(err);
        });
      },
      expandAllNodes(state,data=''){
        //console.log('state:',state);
        this.expandAll=state;
        if(data==''){
          data=this.data;
        }
        this.expandAll=state;
        data.forEach(item=>{
          //console.log(item);
          if(item.ID!=0){
            this.$refs.tree.store.nodesMap[item.ID].expanded=state;
          }

          if(item.children && item.children.length>0){
            this.expandAllNodes(state,item.children);
          }
        })
      },
      refreshShunxu(){
        if (!this.currentNode) {
          this.$message({
            type: 'error',
            message: '请先选择要重算的节点'
          });
          return;
        }
        else if(!this.currentNode.children || this.currentNode.children.length==0){
          this.$message({
            type: 'error',
            message: '当前节点没有子级'
          });
          return;
        }

        let url="/Handler/MuLu.ashx?mode=refreshShunxu";
        this.$ajax.post(url,{ParentID: this.form.ParentID}).then((response)=>{
          //console.log(response.data);
          //let jsonData=JSON.parse(response.bodyText);
          //console.log(jsonData[0]);
          //this.currentID=0;
          let value=response.data;

          let errorCode=value.errorCode;

          if(errorCode=="0")
          {
            this.$alert('重算子级顺序成功', '系统提示', {
              confirmButtonText: '确定',
              callback: action => {
                this.requestData();
              }
            });          }
          else
          {
            let desc=value.desc;
            this.$message({
              type: 'error',
              message: desc
            });
          }        },function(err){
          //console.log(err);
        });
      },
      filterData(data){
        //console.log(data);
        let ml=data.filter(item=>{
          if((item.children&&item.children.length>0) || item.节点类别=='0'){
            if(item.children&&item.children.length>0){
              item.children=this.filterData(item.children);
            }
						return item.节点类别=='0' || item.AutoID=='0';
          }
        });

        return ml;
      },
			setTableHeight() {
			  let h = 160;
			  let h1 = 0;
			  let that = this;
			  this.$nextTick(() => {
			    
			    let height = document.body.clientHeight;
			    //console.log('this.currentMenuFenZu',this.currentMenuFenZu,height);
			    // if (this.currentMenuFenZu == "xmzx") {
			    //   height -= 40;
			    // }
			    that.tableHeight = height - h - h1;
			
			    that.tableHeight -= 40;
			  });
			},
			async getAppList(){
			  let url="/Handler/App.ashx?mode=GetAPPList";
				
				let payload={};
				
				const {data: resData} = await this.$ajax.post(url,payload);
				
				let errorCode=resData.errorCode;
				
				if(errorCode=='0'){
					this.AppList=resData.data;
					
					if(this.AppList.length>0 && (!this.AppID || this.AppID=='0')){
						this.AppID=this.AppList[0].AutoID;
						
						sessionStorage.setItem('MuLuAppID', this.AppID);
					}
				}
				else{
					let desc=resData.desc;
					
					this.$message({
					  type: 'error',
					  message: '获取失败，' + desc
					});
				}
			  
			},
			selectApp(val){
				//console.log('selectApp', val);
				
				sessionStorage.setItem('MuLuAppID', this.AppID);
				
				this.form.AppID=val;
				
				this.requestData();
			},
			getValue(title,value,pathkey){
				//console.log('getValue',title,value,pathkey);
				
			  this.form2.ParentID = value;
			  
			  //console.log(this.form2);
			},
			
    },
    props: [],
		created(){
			
		},
    async mounted(){
			this.AppID=sessionStorage.getItem('MuLuAppID');
			this.currentID=sessionStorage.getItem('MuLuID');
			
			//console.log('this.AppID', this.AppID);
			
			if(this.AppID && this.AppID!='0'){
				
				this.form.AppID=this.AppID;
				
			}
			
			await this.getAppList();
			
      this.requestData();

			this.setTableHeight();
    },
    beforeDestroy(){
    	//console.log('beforeDestroy', this.dingShiQiArr.length,this);
    	
    	this.dingShiQiArr.forEach(item=>{
    		clearTimeout(item);
    	})
    },
    computed:{
    	currentMenuFenZu(){
        return this.$store.state.currentMenuFenZu;
      }
    },
    watch: {
      filterText(val) {
				val=val.replace(/ /g, '');
				
        this.$refs.tree.filter(val);
      },
			currentMenuFenZu(val) {
			  this.setTableHeight();
			},
			
    }
  }
</script>

<style lang="scss" scoped="scoped">
.main {
  border: 0px solid #F00;
  position: relative;
  padding-top: 0px;
  .menu {
    // background-color: #8899DD;
    padding: 5px;
    padding-top: 10px;
    width: 400px;
  }
  .tools {
    // position: fixed;
    // top: 115px;
    // left: 125px;
    width: calc(100vw - 140px);
		min-width: 850px;
    z-index: 99;
    // text-align: left;
    // padding: 5px 20px;
    //padding-top: 0px;
    background-color: #ECF1F5;
    .bt {
      // padding: 7px 15px;
      // font-size: 22px;
    }
  }
  .tools2 {
    position: fixed;
    top: 155px;
    left: 125px;
    width: calc(100vw - 140px);
    z-index: 99;
    // text-align: left;
    // padding: 5px 20px;
    //padding-top: 0px;
    background-color: #ECF1F5;
    .bt {
      // padding: 7px 15px;
      // font-size: 22px;
    }
  }
	.cont{
		overflow-y: auto;
	}
}
.el-radio {
  margin-right: 0;
}

/deep/ .el-radio input[aria-hidden="true"] {
  display: none !important;
}

/deep/ .el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
  box-shadow: none !important;
}
.tools3{
	padding: 8px 0;
	padding-bottom: 8px;
	padding-left: 20px;
	min-width: 840px;
	white-space: nowrap;
	overflow: hidden;
	text-align: left;
}
/deep/ .el-button+.el-button{
	margin-left: 10px;
}
/deep/ .el-button--text{
	font-size: 16px !important;
	color: #333333;
}
/deep/ .el-button--text:hover{
	font-size: 16px !important;
	color: #1E90FF;
}
/deep/ .el-tree-node__content{
	height: 32px;
	line-height: 32px;
}
/deep/ .el-button--small{
	padding: 8px 12px;
	font-size: 16px;
}
</style>
